export const setColorTheme = () => {
  document.body.classList.remove('dark');
  document.documentElement.classList.remove('dark');
  document.documentElement.style.setProperty('color-scheme', 'light');
};
